module.exports = __webpack_public_path__ + "static/media/set-up.b7a4d452.svg";